export default __webpack_public_path__ + "static/media/single-col.f682a9e4.svg";